/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1AgencyrightscategoryQueryResponse } from '../../types/GetV1Agencyrightscategory.ts'

export const getV1AgencyrightscategoryQueryKey = () =>
    [{ url: '/v1/AgencyRightsCategory' }] as const

export type GetV1AgencyrightscategoryQueryKey = ReturnType<typeof getV1AgencyrightscategoryQueryKey>

/**
 * {@link /v1/AgencyRightsCategory}
 */
export async function getV1Agencyrightscategory(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1AgencyrightscategoryQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/AgencyRightsCategory`, ...requestConfig })
    return res
}

export function getV1AgencyrightscategoryQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1AgencyrightscategoryQueryKey()
    return queryOptions<
        ResponseConfig<GetV1AgencyrightscategoryQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1AgencyrightscategoryQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Agencyrightscategory(config)
        },
    })
}

/**
 * {@link /v1/AgencyRightsCategory}
 */
export function useGetV1Agencyrightscategory<
    TData = ResponseConfig<GetV1AgencyrightscategoryQueryResponse>,
    TQueryData = ResponseConfig<GetV1AgencyrightscategoryQueryResponse>,
    TQueryKey extends QueryKey = GetV1AgencyrightscategoryQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1AgencyrightscategoryQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1AgencyrightscategoryQueryKey()

    const query = useQuery(
        {
            ...getV1AgencyrightscategoryQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
